import React from 'react'
import {Box, AppBar, Toolbar, Button} from '@mui/material';
import { useTheme } from '@mui/material/styles'
import { makeStyles } from "@material-ui/core";
import { useNavigate } from "react-router-dom";

import logo from '../../assets/logo.png'


const useStyles = makeStyles((theme) => ({
  link: {
    textDecoration: "none",
    color: "white",
    fontSize: "20px",
    cursor: 'pointer',
    "&:hover": {
      color: '#B3D34B',
      borderBottom: "1px solid white",
    },
  },
  active: {
    color: '#B3D34B',
    fontSize: "20px",
  },
}));


export default function NavBar() {
  const theme = useTheme()
  const classes = useStyles()
  const navigate = useNavigate()
  const active = window.location.pathname

  return (
    <Box 
    container 
    spacing={3}
    sx={{marginTop: '10px', width: '100%'}}
    >
      <AppBar 
      boxShadow={3}
      position="static" 
      sx={{backgroundColor: theme.palette.primary.dark}}>
        <Toolbar sx={{justifyContent: 'space-evenly'}}>
          <Box
              component="img"
              sx={{
                maxWidth: 160,
                position: 'absolute',
                left: 0
              }}
              alt="logo"
              src={logo}
          />
          <Box>
            <Button onClick={()=> navigate('/')} 
            className={active === "/" ? classes.active : classes.link}>
              Dashboard
            </Button>
            <Button onClick={()=> navigate('/contacts')} 
            className={active === "/contacts" ? classes.active : classes.link}>
              Contacts
            </Button>
            <Button onClick={()=> navigate('/templates')} 
            className={active === "/templates" ? classes.active : classes.link}>
              Templates
            </Button>
          </Box>
        </Toolbar>
      </AppBar>
    </Box>
  )
}